module.exports = __webpack_public_path__ + "media/images/wines/Riesling-1-PS-71aeb4c9a7c66b60554f1dc4695a64c8.jpg";